import React, { useMemo } from "react";

const CourseDetailChapterList = ({ chapters }) => {
  const BASE_URL = process.env.REACT_APP_GALLERY_URL;

  // Parse the documents JSON string
  const documents = useMemo(() => {
    try {
      const parsed = chapters?.documents ? JSON.parse(chapters.documents) : [];
      return parsed;
    } catch (error) {
      return [];
    }
  }, [chapters]);

  // Function to get the appropriate SVG icon based on document type
  const getDocumentIcon = (type) => {
    if (!type) {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 2C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2H6ZM6 4H13L18 9V20H6V4Z"
            fill="#82BD00"
          />
        </svg>
      );
    }
    if (type === "application/pdf") {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 2C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2H6ZM6 4H13L18 9V20H6V4ZM8 12H16V14H8V12ZM8 16H13V18H8V16Z"
            fill="#F05203"
          />
        </svg>
      );
    } else if (
      type === "application/msword" ||
      type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 2C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2H6ZM6 4H13L18 9V20H6V4ZM8 12H10V18H8V12ZM12 12H14V18H12V12ZM16 12H18V18H16V12Z"
            fill="#2B579A"
          />
        </svg>
      );
    } else if (type === "text/plain") {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 2C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2H6ZM6 4H13L18 9V20H6V4ZM8 12H16V13H8V12ZM8 14H16V15H8V14ZM8 16H16V17H8V16Z"
            fill="#666666"
          />
        </svg>
      );
    }
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 2C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2H6ZM6 4H13L18 9V20H6V4Z"
          fill="#82BD00"
        />
      </svg>
    );
  };

  // Handle click to open document in a new tab
  const handleDocumentClick = (doc) => {
    const fullUrl = doc.path.startsWith("http")
      ? doc.path
      : `${BASE_URL}${doc.path}`;
    console.log("Opening URL:", fullUrl); // Debug log
    window.open(fullUrl, "_blank"); // Open URL in a new tab
  };

  return (
    <div className="chapters p-5">
      {documents.length > 0 ? (
        documents.map((doc, index) => (
          <div
            key={index}
            className="chapter-card py-12 px-12 px-sm-20 mb-11 d-flex align-items-center cursor-pointer hover-bg-light"
            onClick={() => handleDocumentClick(doc)}
          >
            <div className="chapter-icon d-flex justify-content-center align-items-center me-15 ah-text-lg flex-shrink-0">
              {getDocumentIcon(doc.type)}
            </div>
            <div className="d-flex justify-content-between align-items-center w-100">
              <div>
                <div className="ah-text-md fw-semibold chapter-title">
                  {doc.name}
                </div>
                <div className="ah-text-base fw-normal chapter-type">
                  {doc.type === "application/pdf"
                    ? "PDF Document"
                    : doc.type === "application/msword" ||
                      doc.type ===
                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    ? "Word Document"
                    : doc.type === "text/plain"
                    ? "Text Document"
                    : doc.type}
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="ah-text-base fw-normal alert alert-info">
          No documents available
        </div>
      )}
    </div>
  );
};

export default CourseDetailChapterList;
